import { useRef, useState, useEffect } from "react";

const Tooltip = ({ text, children, tooltipStyle = {}, buttonStyle = {} }) => {
  const [show, setShow] = useState(false);
  const tooltipRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    function handleClickOutside(event) {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);

  const defaultButtonStyle = {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '20px',
    padding: 0
  };

  const defaultTooltipStyle = {
    position: "absolute",
    left: "100%",
    top: 0,
    marginLeft: "8px",
    background: "#222",
    color: "#fff",
    minWidth: '400px',
    padding: "8px 12px",
    borderRadius: "4px",
    fontSize: "13px",
    zIndex: 1000,
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    whiteSpace: "pre-line"
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        ref={buttonRef}
        style={{ ...defaultButtonStyle, ...buttonStyle }}
        type="button"
        onClick={() => setShow((prev) => !prev)}
        tabIndex={0}
        aria-label="Show tooltip"
      >
        {children}
      </button>
      {show && (
        <div ref={tooltipRef} style={{ ...defaultTooltipStyle, ...tooltipStyle }}>
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
